export interface IItemSpawns {
	code: number;
	name: string;
	areaType: string;
	areaCode: number;
	dropTime: number;
	itemCode: number;
	dropPoint: string;
	dropCount: number;
}
